import { get, post } from '../tools/http';
import { copy, comparer } from '../tools/comparer';
import { isoStringToYYYYMMDD } from '../tools/moment-date';

export default {
    state: {
        educations: [],
        educationsServer: [],
    },
    mutations: {
        setEducations: (state, educations) => {
            state.educations = educations;
            state.educationsServer = copy(educations);
        },

        changeEducations: (state, education) => {
            state.educations = education;
        },

        setEducation: (state, education) => {
            state.educations = [
                ...state.educations,
                education,
            ];
            state.educationsServer = [
                ...state.educationsServer,
                copy(education),
            ];
        },

        updateEducation: (state, education) => {
            let educationFinderIndex = state.educations.findIndex((edu) => {
                return String(edu.id) === String(education.id);
            });
            if (educationFinderIndex > -1) {
                state.educations = state.educations.map((el, index) => {
                    return index === educationFinderIndex
                        ? education
                        : el;
                });
                state.educationsServer = state.educationsServer.map((el, index) => {
                    return index === educationFinderIndex
                        ? copy(education)
                        : el;
                });
            }
        },
        removeEducation: (state, index) => {
            state.educations = state.educations.filter((el, elIndex) => elIndex !== index);
            state.educationsServer = state.educationsServer.filter((el, elIndex) => elIndex !== index);
        },
    },
    actions: {
        loadEducations: async (ctx) => {
            let educations = await get('profile', 'education');
            ctx.commit('setEducations', educations.education.map((edu)=>{
                return {
                    ...edu,
                    dateStart: isoStringToYYYYMMDD(edu['dateStart']),
                    dateEnd: isoStringToYYYYMMDD(edu['dateEnd']),
                };
            }));
        },

        addEducation: async (ctx) => {
            const newEducation = {
                dateEnd: null,
                city: null,
                dateStart: null,
                foreignDegreeId: null,
                document: null,
                foreignLevelId: null,
                isNow: null,
                foreignPlaceId: null,
                qualification: "",
                foreignSpecialtyId: null,
                schoolClass: null,
                educationPlace: null,
                isHonorsDegree: false,
            };
            const postParams = [
                'profile',
                'education/create',
                newEducation,
                true,
            ];
            let newEducationId = await post(...postParams);
            ctx.commit('setEducation', {
                ...newEducation,
                id: newEducationId.id,
            });
        },

        updateEducation: async (ctx, {edu, index}) => {
            const diff = comparer(ctx.state.educationsServer[index], edu, true);
            // todo file as object
            let prediff = Object.keys(diff).reduce((acc, item) => {
                if (item == 'document') {
                    return {...acc, [item]: diff[item] ? diff[item]['id'] : null };
                } else {
                    return {...acc, [item]: diff[item]};
                }
            }, {});

            if (Object.keys(diff).length > 0) {
                const postParams = [
                    'profile',
                    'education/update',
                    {...prediff, id: edu.id},
                    true,
                ];
                await post(...postParams);
                ctx.commit('updateEducation', edu);
            }
        },

        removeEducation: async (ctx, {education, index}) => {
            if (education.id) {
                const getParams = [
                    'profile',
                    `education/${education.id}/remove`,
                ];
                await get(...getParams);
            }
            ctx.commit('removeEducation', index);
        },
    },
    getters: {
        getEducations: state => state.educations,
    },
};